import { componentWrapper } from '@arco-design/mobile-utils';
import { componentGenerator } from './menu';
import { Popover } from './popover';
export * from './type';
/** 气泡菜单 */

var Menu = componentGenerator(Popover);
/**
 * 气泡卡片，支持六个方向，小箭头在各个方向均基于挂载的子元素居中放置，支持受控和非受控模式。
 * @name 气泡卡片
 * @type 信息展示
 */

export default componentWrapper(Popover, {
  Menu: Menu
});